import React from 'react';

const ProfilePage: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Profile</h1>
      <div className="bg-white shadow rounded-lg p-6">
        <p>User profile and settings will be implemented here.</p>
        <p className="mt-2 text-gray-600">This will include user information, preferences, and account settings.</p>
      </div>
    </div>
  );
};

export default ProfilePage; 